// extracted by mini-css-extract-plugin
module.exports = {"category":"category_category__WRC2B","sliderWrap":"category_sliderWrap__ByC84","selectWrap":"category_selectWrap__1AAVx"};